declare module '*.scss';

declare module 'color-contrast-checker';
